import { wencesApi } from "@/api/wencesApi";

export const PER_VIEW_ROW_HIDE_MODULE = "per_view_row_hide_module";
export const SCOPE_GENERAL_ACCOUNT_STATEMENT = "general_account_statement";
export const SCOPE_REPORT = "report";
export const SCOPE_BOLSA_COMERCIALES = "bolsa_comerciales";
/** Listados financieros: el oculto es propio de la vista, no cruza a Shipping. */
export const SCOPE_FINANCIAL_PAYMENTS = "financial_payments";
export const SCOPE_FINANCIAL_COLLECTS = "financial_collects";
/** Pestaña "Situación de cobros": la fila es una proforma, no un cobro. */
export const SCOPE_FINANCIAL_COLLECT_SITUATION = "financial_collect_situation";

/**
 * Estado del módulo: si está activo y en qué reportes se pueden ocultar filas
 * (los demás reportes no ofrecen ocultar).
 */
export async function fetchPerViewRowHideStatus() {
  try {
    const res = await wencesApi.get("/api/per-view-row-hide/status");
    const data = res.data && res.data.success ? res.data.data || {} : {};
    return {
      active: !!data.active,
      reportIds: Array.isArray(data.reportIds) ? data.reportIds.map(String) : [],
    };
  } catch (e) {
    return { active: false, reportIds: [] };
  }
}

export async function fetchPerViewRowHideActive() {
  const { active } = await fetchPerViewRowHideStatus();
  return active;
}

export async function hidePerViewRow({ scopeType, scopeId, rowKey, modelName, shipping }) {
  const res = await wencesApi.post("/api/per-view-row-hide/rows", {
    scopeType,
    scopeId,
    rowKey,
    modelName,
    shipping,
  });
  return res.data;
}

export async function unhidePerViewRow({ scopeType, scopeId, rowKey, shipping, modelName }) {
  const res = await wencesApi.post("/api/per-view-row-hide/rows/unhide", {
    scopeType,
    scopeId,
    rowKey,
    shipping,
    modelName,
  });
  return res.data;
}

export async function bulkPerViewRowHide({ action, rows }) {
  const res = await wencesApi.post("/api/per-view-row-hide/rows/bulk", {
    action,
    rows,
  });
  return res.data;
}
